import React, { useState, useEffect } from 'react'
import { CustomerDto } from '@ivy-monorepo/shared'
import Table from '../../components/Table'
import { adminService } from '../../services/admin.service'

const CustomersPage = () => {
  const [customers, setCustomers] = useState<CustomerDto[] | undefined>(undefined)

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const response = await adminService.getCustomers()
        setCustomers(response)
      } catch (err) {
        console.error('Failed to fetch customers', err)
      }
    }

    fetchAccounts()
  }, [])

  return (
    <div>
      <div className="customers-container">
        <h2>Customers</h2>
        <Table
          id="customers"
          name="Customers"
          keyField="publicId"
          initialSortColumn="name"
          columns={[
            { label: '', accessor: 'imageUrl', type: 'avatar' },
            { label: 'Name/Code', accessor: 'name', type: 'customerNameAndCode' },
            { label: 'Status', accessor: 'status', type: 'enum', enumName: 'CustomerStatus' },
            { label: 'Last active', accessor: 'lastActiveAt', type: 'datetime' },
            { label: 'Created', accessor: 'createdAt', type: 'datetime' },
          ]}
          sourceData={customers || []}
          isPropertyBarVisible={false}
          filterTerms=""
          onRowClick={() => {}}
        />
      </div>
    </div>
  )
}

export default CustomersPage
